import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
  tabsRoot: {
    minHeight: 38,
  },
  nestedTabsRoot: {
    minHeight: 36,
    borderBottom: '0 none',
  },
  nestedTabRoot: {
    minHeight: 36,
  },
  nestedTabWrapper: {
    fontSize: '13px !important',
    zIndex: 1,
  },
  labelWrap: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    display: 'inline-block',
    maxWidth: 215,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: '4px',
  },
  tabIndicator: {
    height: '100%',
    borderRadius: 18,
    backgroundColor: `${theme.palette.primary.main}18`,
  },
}));

export default useStyles;
